<template>
    <div :class="['story-heading']">
        <div class="block">
            <div class="info">
                <span class="date">{{formattedDate}}</span>
                <span class="tag" v-for="taxon in layout.taxonomy">{{taxon.name}}</span>
            </div>
            <div class="sharing">
                <span class="caption">Partager</span>
                <LinkHover
                    type="button"
                    :class="['share-cta']"
                    @click.native="(e) => open(e, `https://www.facebook.com/sharer.php?u=${currentLink}`, 'Facebook')"
                >
                    <span
                        class="default"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="twtr-icon  twtr-color-fill--blue-dark  has-hover">
                        <path d="M16.75,9H13.5V7a1,1,0,0,1,1-1h2V3H14a4,4,0,0,0-4,4V9H8v3h2v9h3.5V12H16Z"></path>
                        </svg>
                    </span>
                    <template v-slot:hover>
                        <span
                            class="hover"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="twtr-icon  twtr-color-fill--blue-dark  has-hover">
                            <path d="M16.75,9H13.5V7a1,1,0,0,1,1-1h2V3H14a4,4,0,0,0-4,4V9H8v3h2v9h3.5V12H16Z"></path>
                            </svg>
                        </span>
                    </template>
                </LinkHover>
                <LinkHover
                    type="button"
                    :class="['share-cta']"
                    @click.native="(e) => open(e, `http://www.twitter.com/share?url=${currentLink}`, 'Twitter')"
                >
                    <span
                        class="default"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="twtr-icon  twtr-color-fill--blue-dark  has-hover">
                            <path opacity="0" d="M0 0h24v24H0z"></path>
                            <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"></path>
                        </svg>
                    </span>
                    <template v-slot:hover>
                        <span
                            class="hover"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="twtr-icon  twtr-color-fill--blue-dark  has-hover">
                                <path opacity="0" d="M0 0h24v24H0z"></path>
                                <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"></path>
                            </svg>
                        </span>
                    </template>
                </LinkHover>
                <LinkHover
                    type="button"
                    :class="['share-cta']"
                    @click.native="(e) => open(e, `https://www.linkedin.com/sharing/share-offsite/?url=${currentLink}`, 'LinkedIn')"
                >
                    <span
                        class="default"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="twtr-icon  twtr-color-fill--blue-dark  has-hover">
                            <rect height="11" width="4" x="3" y="9"></rect>
                            <circle cx="5" cy="5" r="2"></circle>
                            <path d="M16.5,8.25A4.47251,4.47251,0,0,0,13,9.95343V9H9V20h4V13a2,2,0,0,1,4,0v7h4V12.75A4.5,4.5,0,0,0,16.5,8.25Z"></path>
                        </svg>
                    </span>
                    <template v-slot:hover>
                        <span
                            class="hover"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="twtr-icon  twtr-color-fill--blue-dark  has-hover">
                                <rect height="11" width="4" x="3" y="9"></rect>
                                <circle cx="5" cy="5" r="2"></circle>
                                <path d="M16.5,8.25A4.47251,4.47251,0,0,0,13,9.95343V9H9V20h4V13a2,2,0,0,1,4,0v7h4V12.75A4.5,4.5,0,0,0,16.5,8.25Z"></path>
                            </svg>
                        </span>
                    </template>
                </LinkHover>
            </div>
        </div>
    </div>
</template>

<script>
import LinkHover from '@/components/animation/LinkHover'

export default {
    components: {
        LinkHover
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        currentLink() {
            return process.env.VUE_APP_URL + this.$router.currentRoute.path
        },
        formattedDate() {
            return this.layout.date.split('/').join('.')
        }
    },
    methods: {
        open(e, url, domain) {
            e.preventDefault()
            window.open(url, domain, 'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.story-heading
    border-bottom: 1px solid #e5e5e5
    padding-bottom: 20px
.block
    display: flex
    align-items: center
    padding-left: 8%
    @include media-breakpoint-down($sm)
        flex-direction: column
        align-items: flex-start
        padding-left: 0%
.info
    flex: 1
    display: flex
    line-height: 1.5
.tag
    margin-left: 37px
    display: flex
    border-bottom: 1px solid #636772
.sharing
    display: flex
    align-items: center
    @include media-breakpoint-down($sm)
        align-self: flex-end
        margin-top: 10%
    @media print
        display: none
.caption
    font-size: 17px
    font-weight: 500
    color: #ff2b2a
    margin-right: 37px
    @include media-breakpoint-down($lg)
        display: none
.share-cta
    &+.share-cta
        .default,
        .hover
            border-left: none
.default,
.hover
    width: 74px
    height: 74px
    display: flex
    align-items: center
    justify-content: center
    border: 1px solid #e5e5e5
    @include media-breakpoint-down($sm)
        width: 50px
        height: 50px

    svg
        /deep/ path,
        rect,
        circle
            fill: #c5c6c9
.hover
    background-color: #ff2b2a
    svg
        /deep/ path,
        rect,
        circle
            fill: #ffffff
</style>
